import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_PIN } from "../../../config/api";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import {
  closeModal,
  showErrorModal,
  showSuccessModal,
} from "../../reducers/messageSlice";
import { fetchUserProfile } from "../profile/getProfile";
import mixpanel from "mixpanel-browser";
import { toast } from "react-toastify";

export const resetTransactionPin = createAsyncThunk(
  "user/resetTransactionPin",
  async ({ payload, cb, resetForm }, { dispatch, getState }) => {
    const { profile, user } = getState().onboarding;
    const { userBanks } = getState().bank;
    try {
      const { data } = await Client({
        method: "POST",
        path: API_PIN,
        data: payload,
      });
      dispatch(fetchUserProfile());

      toast.success(
        payload?.current_pin
          ? "Transaction Pin Updated Successfully"
          : "Transaction Pin Created Successfully"
      );
      cb();

      if (
        userBanks?.length > 1 &&
        profile?.nok_email &&
        !payload?.current_pin &&
        !user?.hasSetPin
      ) {
        mixpanel.track("WEB-Onboarded", {
          type: "Onboarding",
        });
      }
      // setTimeout(() => {
      //   dispatch(closeModal());
      // }, 3000);
      // mixpanel.track("Success", {
      //   type: "Onboarding",
      //   subtype: "update-PIN",
      // });
      return data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      cb();
      resetForm();
      // dispatch(showErrorModal(msg || "Transaction Pin failed"));
      // mixpanel.track("Error", {
      //   type: "Onboarding",
      //   subtype: "update-PIN",
      //   message: msg,
      // });

      throw error;
    }
  }
);
